import './ProductPackBanner.less';
import { useEffect, useState } from 'preact/hooks';
import { apiClient } from '../../services/ApiClient';
import ProductPackSelector from '../../components/product/pack-selector/ProductPackSelector';
import type { Product } from '../../models/Product';
import type { ProductGroup } from '../../models/ProductGroup';
import Icon from '../../components/icon/Icon';
import useAppDispatch from '../../hooks/useAppDispatch';
import { useTranslation } from '../../hooks/useTranslation';
import { dispatchEvent } from '../../services/EventService';

export type ProductPackBannerProps = {
    productIds: string[];
    title: string;
};

const ProductPackBanner = ({ productIds, title }: ProductPackBannerProps) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [productGroups, setProductGroups] = useState<ProductGroup[]>([]);
    const [fixedProducts, setFixedProducts] = useState<Product[]>([]);

    useEffect(() => {
        apiClient.assistant
            .productPacks({ body: { productIds } })
            .then(result => {
                setProductGroups(
                    result.productGroupsByCategory
                        .map(group => ({
                            products: group.products,
                            title:
                                group.categoryFilter?.categoryTranslatedValue ||
                                group.categoryFilter?.categoryValue ||
                                ''
                        }))
                        .slice(0, 3)
                );
                setFixedProducts(result.packWithProducts);
            })
            .catch(() => {});
    }, [productIds]);

    if (productGroups.length === 0 || fixedProducts.length === 0) {
        return null;
    }
    return (
        <div className={`bri-ProductPackBanner`}>
            <div className="bri-ProductPackBanner-header">
                <div className="bri-ProductPackBanner-title bri-TitleBoldFont">
                    <Icon iconId="brilliant-logo" />
                    {title}
                </div>
            </div>
            <div className="bri-ProductPackBanner-content">
                <ProductPackSelector
                    fixedGroup={{
                        products: fixedProducts,
                        title: t('PRODUCT_PACK_BANNER_CURRENT_PRODUCT')
                    }}
                    source="web"
                    alternativesGroups={productGroups}
                    onAddToCart={products => {
                        if (products.length === 1) {
                            void dispatch.featureState.startFeature({
                                featureType: 'product-detail',
                                productId: products[0].productId,
                                product: products[0],
                                source: 'web'
                            });
                        } else {
                            void dispatch.featureState.startFeature({
                                featureType:
                                    'product-multi-variant-add-to-cart',
                                products
                            });
                            dispatchEvent({
                                type: 'bri.open_add_many_products_to_cart',
                                isInteraction: true,
                                source: 'web',
                                productIds: products.map(
                                    product => product.productId
                                )
                            });
                        }
                    }}
                />
            </div>
        </div>
    );
};

export default ProductPackBanner;
